import { library } from '@fortawesome/fontawesome-svg-core';
import { faMap } from '@fortawesome/free-regular-svg-icons/faMap';

library.add([
	faMap,
]);
